/*
 * ImprintContainer.jsx 28.03.18
 *
 * (c) 2018 ergovia GmbH
 */

import {connect} from 'react-redux';
import {showImprintDialog, hideImprintDialog} from '../actions/actions';
import ImprintButton from '../components/imprint/ImprintButton';

const mapDispatchToProps = {showImprintDialog, hideImprintDialog};

const mapStateTopProps = ({imprint_dialog}) => ({imprint_dialog});

export default connect(mapStateTopProps, mapDispatchToProps)(ImprintButton);



// WEBPACK FOOTER //
// ./src/de/ergovia/containers/ImprintContainer.js